var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileMagnifyingGlassRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 14.5C3.725 14.5 3.5 14.275 3.5 14V2C3.5 1.725 3.725 1.5 4 1.5H9V4C9 4.55313 9.44687 5 10 5H12.5V14C12.5 14.275 12.275 14.5 12 14.5H4ZM4 0C2.89688 0 2 0.896875 2 2V14C2 15.1031 2.89688 16 4 16H12C13.1031 16 14 15.1031 14 14V4.82812C14 4.29688 13.7906 3.7875 13.4156 3.4125L10.5844 0.584375C10.2094 0.209375 9.70312 0 9.17188 0H4ZM10.5 9.5C10.5 7.84375 9.15625 6.5 7.5 6.5C5.84375 6.5 4.5 7.84375 4.5 9.5C4.5 11.1562 5.84375 12.5 7.5 12.5C8.05625 12.5 8.575 12.35 9.02187 12.0875L10.2188 13.2844C10.5125 13.5781 10.9875 13.5781 11.2781 13.2844C11.5687 12.9906 11.5719 12.5156 11.2781 12.225L10.0813 11.0281C10.3469 10.5812 10.4969 10.0594 10.4969 9.5H10.5ZM7.5 8C7.89782 8 8.27936 8.15804 8.56066 8.43934C8.84196 8.72064 9 9.10218 9 9.5C9 9.89782 8.84196 10.2794 8.56066 10.5607C8.27936 10.842 7.89782 11 7.5 11C7.10218 11 6.72064 10.842 6.43934 10.5607C6.15804 10.2794 6 9.89782 6 9.5C6 9.10218 6.15804 8.72064 6.43934 8.43934C6.72064 8.15804 7.10218 8 7.5 8Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileMagnifyingGlassRegular);
export default __webpack_public_path__ + "static/media/file-magnifying-glass-regular.f30464f63a5df490a7292b35eaf6899f.svg";
export { ForwardRef as ReactComponent };